import { useTokenStore } from '@/store'
import axios, { AxiosInstance, AxiosResponse } from 'axios'
// import { showToast } from 'vant'

const baseURL = process.env.NODE_ENV === 'development' ? '/mall-api/' : '/zd-api'
// const baseURL = process.env.NODE_ENV === 'development' ? '/mall-api/' : 'https://open.test.luojigou.vip/'
// const baseURL = "http://192.168.1.147:8081/"
// const baseURL = "/mall-api/"
// const baseURL = "/app-api/"
// const baseURL = process.env.NODE_EN === 'development' ? 'https://open.api.luojigou.vip/' : '/zd-api'
// const baseURL = process.env.NODE_ENV === 'development' ? '/https://open.api.luojigou.vip/' : '/zd-api'
// const baseURL = '/zd-api'

// 'https://open.api.luojigou.vip/'

const instance = axios.create({
  baseURL: baseURL,
  timeout: 10000
})

instance.interceptors.request.use((config) => {
  try {
    config.headers.token = useTokenStore().get()
  } catch (error) {

  }

  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

instance.interceptors.response.use(<T>(response: AxiosResponse<T>) => {
  const data: any = response.data
  console.log('data:', data.status)

  // 检查业务状态码
  if (data && (data.status === 401)) {
    // 跳转到登录页面，保持当前域名和路径，并携带redirect参数
    setTimeout(() => {
      const currentUrl = window.location.href
      const hashIndex = currentUrl.indexOf('#')

      if (hashIndex !== -1) {
        // 提取当前的hash路由（包括query参数）
        const currentHash = currentUrl.substring(hashIndex + 1) // 去掉#号
        const baseUrl = currentUrl.substring(0, hashIndex)

        // 将当前路由作为redirect参数传递给login页面
        window.location.href = `${baseUrl}#/login?redirect=${encodeURIComponent(currentHash)}`
      } else {
        // 如果没有hash，直接添加
        window.location.href = `${currentUrl}#/login`
      }
    }, 1500)

    return Promise.reject(new Error(data.msg || '登录已过期'))
  }

  if (data && data.status === 500) {
    console.log('data.msg??????:', data.msg)

    // eslint-disable-next-line
    // @ts-ignore
    // showToast(data.msg || '服务器错误，请稍后重试')
    // showToast(data.msg || '服务器错误，请稍后重试')
    // return Promise.reject(new Error(data.msg || '服务器错误'))
  }

  return response.data
}, (error) => {
  console.log('发生错误')

  // 处理HTTP错误
  if (error.response) {
    const status = error.response.status
    let message = '请求失败，请稍后重试'

    switch (status) {
      case 400:
        message = '请求参数错误'
        break
      case 401:
        message = '未授权，请重新登录'
        // HTTP 401错误也跳转到登录页，携带redirect参数
        setTimeout(() => {
          const currentUrl = window.location.href
          const hashIndex = currentUrl.indexOf('#')

          if (hashIndex !== -1) {
            const currentHash = currentUrl.substring(hashIndex + 1)
            const baseUrl = currentUrl.substring(0, hashIndex)
            window.location.href = `${baseUrl}#/login?redirect=${encodeURIComponent(currentHash)}`
          } else {
            window.location.href = `${currentUrl}#/login`
          }
        }, 1500)
        break
      case 403:
        message = '拒绝访问'
        break
      case 404:
        message = '请求资源不存在'
        break
      case 500:
        message = '服务器错误'
        break
      case 502:
        message = '网关错误'
        break
      case 503:
        message = '服务不可用'
        break
      case 504:
        message = '网关超时'
        break
    }

    // @ts-ignore
    // showToast({
    //   type: 'fail',
    //   message: error.response.data?.message || message
    // })
  } else if (error.request) {
    // @ts-ignore
    // showToast({
    //   type: 'fail',
    //   message: '网络连接失败，请检查网络'
    // })
  } else {
    // @ts-ignore
    // showToast({
    //   type: 'fail',
    //   message: error.message || '请求失败'
    // })
  }

  return Promise.reject(error)
})

export default function request <T> (config: any) {
  return instance.request<AxiosInstance, T>(config)
}
